import React from "react";
import cn from "classnames";
import PropTypes from "prop-types";
import {createUseStyles} from "react-jss";
import {defaultFontSize, greenColor, primaryTextColor, redColor, rgba} from "~/theme";
import UIIcon from "~/old-ui/UIIcon";

export default function UINotification({success, danger, title, text, closable, onClose, className, ...props}) {
  const classes = useStyles();

  return (
    <div className={cn(classes.root, {
      [classes.success]: success,
      [classes.danger]: danger,
    }, className)} {...props}>
      {title && <h3 className={classes.title}>{title}</h3>}
      {text && <div className={classes.text}>{text}</div>}
      {(closable !== undefined) && (
        <UIIcon
          name='fa-times'
          tabIndex={0}
          className={classes.close}
          onClick={onClose}
        />
      )}
    </div>
  )
}

UINotification.propTypes = {
  success: PropTypes.bool,
  danger: PropTypes.bool,
  title: PropTypes.any,
  text: PropTypes.any,
  closable: PropTypes.bool,
  onClose: PropTypes.func,
};

const useStyles = createUseStyles({
  root: {
    color: primaryTextColor,
    padding: [[10, 16]],
    backgroundColor: rgba('#ccc', 0.05),
    border: [[1, 'solid', rgba('#ccc', 0.75)]],
    borderRadius: 6,
    position: 'relative',
  },

  danger: {
    backgroundColor: rgba(redColor, 0.05),
    borderColor: rgba(redColor, 0.75),
    color: redColor,
  },

  success: {
    backgroundColor: rgba(greenColor, 0.05),
    borderColor: rgba(greenColor, 0.75),
    color: greenColor,
  },

  title: {
    fontSize: defaultFontSize,
    fontWeight: 700,
    margin: 0,
    padding: 0,
  },

  text: {
    'h3 + &': {
      marginTop: 4
    }
  },

  close: {
    position: 'absolute',
    top: 10,
    right: 10,
    width: 14,
    height: 14,
    cursor: 'pointer',
  }
});
